"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _chevronRight = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-right"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const ImageInfo = _ref => {
  let {
    prefix,
    vertical,
    ssrIcon,
    children,
    className
  } = _ref;
  const classes = (0, _classnames.default)("".concat(prefix, "image-info"), vertical && "".concat(prefix, "image-info--vertical"), className);
  return _react.default.createElement("span", {
    className: classes
  }, ssrIcon && !vertical && _react.default.createElement(_ssrIcon.default, {
    paths: ssrIcon,
    prefix: prefix,
    className: "".concat(prefix, "image-info__icon")
  }), !vertical && _react.default.createElement(_ssrIcon.default, {
    paths: _chevronRight.default,
    prefix: prefix,
    className: "".concat(prefix, "image-info__chevron")
  }), children && _react.default.cloneElement(children, {
    className: "".concat(prefix, "image-info__text")
  }), ssrIcon && vertical && _react.default.createElement(_ssrIcon.default, {
    paths: ssrIcon,
    prefix: prefix,
    className: "".concat(prefix, "image-info__icon")
  }));
};
ImageInfo.defaultProps = {
  prefix: ''
};
var _default = ImageInfo;
exports.default = _default;